<div class="comment-quill-editor-wrapper">
    <quill-editor 
    #quillInstance
    [modules]="QuillModules"
    [readOnly]="readonly"
    [placeholder]="'Comece a digitar aqui...'"
    [maxLength]="1000" 
    [trimOnValidation]="true"
    (onEditorChanged)="onTextChanged($event)"
    (onEditorCreated)="getQuillInstance($event)"
    ></quill-editor>
    <div class="popup-wrapper" *ngIf="clickedType">
        <input #inputRef type="text" placeholder="Adicione url" (change)="getEmbedOrLinkValue(inputRef.value)">
        <a class="ql-action" (click)="getEmbedOrLink(clickedType)"></a>
        <a class="ql-remove" (click)="close()"></a>
    </div>
</div>

